<template>
      <v-card link flat>
        <v-card-text @click="logout" class="d-block d-md-none" style="padding:14px;">
          <v-icon>mdi-logout</v-icon>
        </v-card-text>
        <v-card-text @click="logout" class="d-none d-md-block" style="width:105px">
          <div>{{ $t('message.logout.title.logout') }}</div>
        </v-card-text>
      </v-card>
</template>

<script>
export default {
  name: 'MpLogout',
  data: () => ({}),
  computed: {},
  methods: {
    logout (ev) {
      this.$store.dispatch('logout')
        .then(this.$router.push({ path: '/auth/login' }))
    }
  }
}
</script>
